import ModalCallNumberEdit, {
  CallNumberEditItem,
  ModalCallNumberEditInterface
} from './ModalCallNumberEdit.vue'

export { ModalCallNumberEdit, CallNumberEditItem, ModalCallNumberEditInterface }
